import React from 'react';

const topBar = () => {
  return (
    <div className='top-bar pt-1 pb-1 text-light'>
      <div className='container'>
        <div className='d-flex justify-content-between'>
          <div className='d-flex pt-2 pb-2'>
            <div className='d-flex align-item-center mr-3'>
              <i className='fas fa-map-marker-alt mr-2' />
              <small>Erzincan Merkez</small>
            </div>
            <div className='d-flex align-item-center'>
              <i className='fas fa-spa mr-2' />
              <small>Gold Nar Güzellik</small>
            </div>
          </div>
          <div className='d-flex pt-2 pb-2'>
            <div className='social-media d-flex align-item-center'>
              <a
                href='https://share.google/wj8How7D9GaZvJJha'
                target='_blank'
                rel='noopener noreferrer'
                className='text-light'
              >
                <i className='fas fa-location-arrow mr-2' />
                <small>Haritada Aç</small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default topBar;
